<template>
    <div class="base">
        <el-card>
            <z-title title="基本设置"></z-title>
            <el-tabs class="mt-10" type="card">
                <el-tab-pane label="基本设置">
                    <base-setting></base-setting>
                </el-tab-pane>
                <el-tab-pane label="客户来源">
                    <user-from></user-from>
                </el-tab-pane>
                <el-tab-pane label="场地类型">
                    <house-type></house-type>
                </el-tab-pane>
                <el-tab-pane label="预定类型">
                    <order-type></order-type>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import BaseSetting from "./sub/BaseSetting";
    import UserFrom from "./sub/UserFrom";
    import OrderType from "./sub/OrderType";
    import HouseType from "./sub/HouseType";

    export default {
        components: {
            HouseType,
            OrderType,
            UserFrom,
            BaseSetting,
            ZTitle
        },
        name: "base1"
    }
</script>

<style scoped lang="scss">
.base{
    min-width: 1000px;
}
</style>